/* ================================================================
   LWL — "Kombinini Tamamla" (sepet çekmecesi öneri alanı)
   ================================================================
   NEREYE EKLENİR:
     Bu dosyayı "assets" klasörüne yükleyin (adı: lwl-cart-upsell.js),
     sonra layout/theme.liquid içinde </body> etiketinden hemen önce,
     cart-progress-bar.js satırının altına ekleyin:

       <script src="{{ 'lwl-cart-upsell.js' | asset_url }}" defer></script>

   NE YAPAR:
     Ürünlerin seçimi snippets/lwl-cart-upsell.liquid içinde sunucu
     tarafında yapılır. Bu script:
       1) Tek varyantlı ürünü tek dokunuşla sepete ekler.
       2) Çok varyantlı üründe (renk/beden) zarif bir seçim paneli açar;
          müşterinin sepetteki BEDENİNİ otomatik seçer (ör. L).
       3) Shopify'ın kendi "ilgili / tamamlayıcı ürün" önerilerinde
          geçen ürünleri birkaç sıra öne alır (ilgi alanı sinyali).
       4) Ekleme sonrası temanın kendi sepet yenilemesini tetikler.
          (Temanın "Eklendi" açılır penceresi çekmece açıkken çıkmasın
          diye ekleme doğrudan /cart/add.js ile yapılır, ardından tema
          GET_CART ile çekmeceyi yeniden çizer.)
   ================================================================ */
(function () {
	'use strict';

	if (window.__lwlCartUpsell) return;
	window.__lwlCartUpsell = true;

	var ROOT_SEL = '[data-lwl-upsell]';
	var SIZE_RE = /beden|boyut|size/i;
	var RECS_TTL = 30 * 60 * 1000; // 30 dk
	var RECS_PRODUCTS = 2;          // sepetteki ilk (en yeni) 2 ürün için öneri al

	var productCache = {};
	var recsMemory = {};
	var pendingStatus = '';

	function routeRoot() {
		var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
		return r || '/';
	}

	// ---------------------------------------------------------------
	// Para biçimi (temanın kendi fonksiyonunu kullanır, yoksa yedek)
	// ---------------------------------------------------------------
	function formatMoney(cents, format) {
		var tc = window.themeCore;
		if (tc && tc.utils && typeof tc.utils.formatMoney === 'function') {
			try { return tc.utils.formatMoney(cents, format); } catch (e) { /* yedeğe düş */ }
		}
		format = format || '{{amount}}TL';
		var re = /\{\{\s*(\w+)\s*\}\}/;
		function fmt(n, dec, th, dp) {
			var parts = (n / 100).toFixed(dec).split('.');
			return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (parts[1] ? dp + parts[1] : '');
		}
		var m = format.match(re);
		var val;
		switch (m ? m[1] : 'amount') {
			case 'amount_no_decimals': val = fmt(cents, 0, ',', '.'); break;
			case 'amount_with_comma_separator': val = fmt(cents, 2, '.', ','); break;
			case 'amount_no_decimals_with_comma_separator': val = fmt(cents, 0, '.', ','); break;
			default: val = fmt(cents, 2, ',', '.');
		}
		return format.replace(re, val);
	}

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;').replace(/'/g, '&#39;');
	}

	// ---------------------------------------------------------------
	// Sepete ekleme + temanın çekmeceyi yenilemesi
	// ---------------------------------------------------------------
	function refreshDrawer() {
		var tc = window.themeCore;
		if (tc && tc.CartApi && typeof tc.CartApi.makeRequest === 'function') {
			return tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART);
		}
		if (tc && tc.EventBus) {
			tc.EventBus.emit('cart:refresh');
			return Promise.resolve();
		}
		window.location.reload();
		return Promise.resolve();
	}

	function addToCart(variantId) {
		return fetch(routeRoot() + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			},
			body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _kaynak: 'Sepet önerisi' } }] })
		})
			.then(function (res) {
				return res.json().then(function (data) {
					if (!res.ok) {
						throw new Error((data && (data.description || data.message)) || 'Ürün sepete eklenemedi.');
					}
					return data;
				});
			})
			.then(function (data) {
				var title = data && data.items && data.items[0] ? data.items[0].product_title : '';
				pendingStatus = title ? '✓ ' + title + ' sepetinize eklendi.' : '✓ Ürün sepetinize eklendi.';
				return refreshDrawer();
			});
	}

	function getProduct(handle) {
		if (productCache[handle]) return productCache[handle];
		productCache[handle] = fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
			headers: { Accept: 'application/json' }
		}).then(function (res) {
			if (!res.ok) throw new Error('Ürün bilgisi alınamadı.');
			return res.json();
		});
		productCache[handle].catch(function () { delete productCache[handle]; });
		return productCache[handle];
	}

	// ---------------------------------------------------------------
	// Varyant seçici
	// ---------------------------------------------------------------
	function findVariant(product, selected) {
		for (var i = 0; i < product.variants.length; i++) {
			var v = product.variants[i];
			var ok = true;
			for (var j = 0; j < selected.length; j++) {
				if (v.options[j] !== selected[j]) { ok = false; break; }
			}
			if (ok) return v;
		}
		return null;
	}

	// i. seçenekte "value" seçilebilir mi? (önceki seçimlere göre, hiyerarşik)
	function isValueAvailable(product, selected, index, value) {
		return product.variants.some(function (v) {
			if (!v.available || v.options[index] !== value) return false;
			for (var j = 0; j < index; j++) {
				if (v.options[j] !== selected[j]) return false;
			}
			return true;
		});
	}

	// i. seçenek değiştiğinde, sonraki seçenekleri uygun bir kombinasyona çek
	function resolveFrom(product, selected, index) {
		for (var k = index + 1; k < selected.length; k++) {
			if (isValueAvailable(product, selected, k, selected[k])) continue;
			var values = product.options[k].values;
			for (var x = 0; x < values.length; x++) {
				if (isValueAvailable(product, selected, k, values[x])) { selected[k] = values[x]; break; }
			}
		}
		return selected;
	}

	function initialSelection(product, cartSizes, prefColor) {
		var first = null;
		var colorIndex = -1;
		product.options.forEach(function (opt, idx) {
			if (colorIndex === -1 && /renk|color/i.test(opt.name || '')) colorIndex = idx;
		});
		// Kartta gösterilen (sepetteki ürünle uyumlu) renk önce seçilir
		if (prefColor && colorIndex > -1) {
			for (var c = 0; c < product.variants.length; c++) {
				if (product.variants[c].available && product.variants[c].options[colorIndex] === prefColor) { first = product.variants[c]; break; }
			}
		}
		for (var i = 0; !first && i < product.variants.length; i++) {
			if (product.variants[i].available) { first = product.variants[i]; break; }
		}
		if (!first) return { selected: null, sizeFromCart: false };
		var selected = first.options.slice();
		var sizeIndex = -1;
		product.options.forEach(function (opt, idx) {
			if (sizeIndex === -1 && SIZE_RE.test(opt.name || '')) sizeIndex = idx;
		});
		if (sizeIndex === -1 || !cartSizes.length) return { selected: selected, sizeFromCart: false, sizeIndex: sizeIndex };

		for (var s = 0; s < cartSizes.length; s++) {
			var size = cartSizes[s];
			// Önce aynı renkte o beden var mı?
			var trial = selected.slice();
			trial[sizeIndex] = size;
			var v = findVariant(product, trial);
			if (v && v.available) return { selected: trial, sizeFromCart: true, sizeIndex: sizeIndex };
			// Yoksa o bedenin stokta olduğu herhangi bir renk
			for (var k = 0; k < product.variants.length; k++) {
				var pv = product.variants[k];
				if (pv.available && pv.options[sizeIndex] === size) {
					return { selected: pv.options.slice(), sizeFromCart: true, sizeIndex: sizeIndex };
				}
			}
		}
		return { selected: selected, sizeFromCart: false, sizeIndex: sizeIndex };
	}

	function imageUrl(src, width) {
		if (!src) return '';
		if (src.indexOf('data:') === 0) return src;
		if (src.indexOf('//') === 0) src = 'https:' + src;
		return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
	}

	function renderPicker(root, picker, state) {
		var product = state.product;
		var variant = findVariant(product, state.selected);
		var available = !!(variant && variant.available);
		var money = root.getAttribute('data-money-format');
		var img = (variant && variant.featured_image && variant.featured_image.src) || product.featured_image;

		var priceHtml = '';
		if (variant) {
			priceHtml = '<span class="lwl-upsell__now">' + escapeHtml(formatMoney(variant.price, money)) + '</span>';
			if (variant.compare_at_price && variant.compare_at_price > variant.price) {
				var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
				priceHtml += '<s class="lwl-upsell__was">' + escapeHtml(formatMoney(variant.compare_at_price, money)) + '</s>' +
					'<span class="lwl-upsell__flag lwl-upsell__flag--inline">-%' + pct + '</span>';
			}
		}

		var optionsHtml = product.has_only_default_variant ? '' : product.options.map(function (opt, i) {
			var hint = (state.sizeFromCart && i === state.sizeIndex && state.selected[i] === state.cartSizeChosen)
				? ' <span class="lwl-picker__hint">· sepetinizdeki bedene göre seçildi</span>'
				: '';
			var chips = opt.values.map(function (val) {
				var enabled = isValueAvailable(product, state.selected, i, val);
				var pressed = state.selected[i] === val;
				return '<button type="button" class="lwl-picker__chip" data-lwl-chip data-index="' + i + '" data-value="' + escapeHtml(val) + '"' +
					' aria-pressed="' + (pressed ? 'true' : 'false') + '"' + (enabled ? '' : ' disabled') + '>' + escapeHtml(val) + '</button>';
			}).join('');
			return '<div class="lwl-picker__option" role="group" aria-label="' + escapeHtml(opt.name) + '">' +
				'<p class="lwl-picker__label">' + escapeHtml(opt.name) + ': <strong>' + escapeHtml(state.selected[i] || '') + '</strong>' + hint + '</p>' +
				'<div class="lwl-picker__chips">' + chips + '</div></div>';
		}).join('');

		picker.innerHTML =
			'<div class="lwl-picker__top">' +
				(img ? '<img class="lwl-picker__img" src="' + escapeHtml(imageUrl(img, 160)) + '" alt="" width="54" height="72">' : '') +
				'<div class="lwl-picker__info">' +
					'<p class="lwl-picker__title" tabindex="-1">' + escapeHtml(product.title) + '</p>' +
					'<div class="lwl-upsell__price">' + priceHtml + '</div>' +
				'</div>' +
				'<button type="button" class="lwl-picker__close" data-lwl-picker-close aria-label="Seçimi kapat">' +
					'<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
				'</button>' +
			'</div>' +
			optionsHtml +
			'<button type="button" class="lwl-picker__submit" data-lwl-picker-submit' + (available ? '' : ' disabled') + '>' +
				(available ? 'Sepete Ekle · ' + escapeHtml(formatMoney(variant.price, money)) : 'Bu seçenek tükendi') +
			'</button>' +
			'<p class="lwl-picker__error" role="alert"></p>';
	}

	function closePicker(root) {
		var picker = root.querySelector('[data-lwl-picker]');
		if (picker) {
			picker.hidden = true;
			picker.innerHTML = '';
			picker._lwlState = null;
		}
		Array.prototype.forEach.call(root.querySelectorAll('[data-lwl-add][aria-expanded="true"]'), function (b) {
			b.setAttribute('aria-expanded', 'false');
		});
	}

	function openPicker(root, card, button) {
		var picker = root.querySelector('[data-lwl-picker]');
		if (!picker) return;

		if (button.getAttribute('aria-expanded') === 'true') {
			closePicker(root);
			return;
		}
		closePicker(root);
		button.setAttribute('aria-expanded', 'true');
		button.setAttribute('aria-busy', 'true');

		var cartSizes = (root.getAttribute('data-sizes') || '').split(',').filter(Boolean);

		getProduct(card.getAttribute('data-handle'))
			.then(function (product) {
				button.removeAttribute('aria-busy');
				if (button.getAttribute('aria-expanded') !== 'true') return; // bu arada kapatıldı
				var init = initialSelection(product, cartSizes, card.getAttribute('data-color') || '');
				if (!init.selected) {
					button.setAttribute('aria-expanded', 'false');
					setStatus(root, 'Bu ürün şu anda stokta yok.');
					return;
				}
				var state = {
					product: product,
					selected: init.selected,
					sizeIndex: init.sizeIndex,
					sizeFromCart: init.sizeFromCart,
					cartSizeChosen: init.sizeFromCart ? init.selected[init.sizeIndex] : null,
					button: button
				};
				picker._lwlState = state;
				renderPicker(root, picker, state);
				picker.hidden = false;
				try { picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) { /* yok say */ }
				var title = picker.querySelector('.lwl-picker__title');
				if (title) title.focus({ preventScroll: true });
			})
			.catch(function (err) {
				button.removeAttribute('aria-busy');
				button.setAttribute('aria-expanded', 'false');
				setStatus(root, err.message || 'Bir sorun oluştu, lütfen tekrar deneyin.');
			});
	}

	function setStatus(root, text) {
		var el = root.querySelector('.lwl-upsell__status');
		if (!el) return;
		el.textContent = text;
		clearTimeout(el._lwlTimer);
		el._lwlTimer = setTimeout(function () { el.textContent = ''; }, 4500);
	}

	// ---------------------------------------------------------------
	// Shopify önerileriyle ince sıralama (ilgi alanı sinyali)
	// ---------------------------------------------------------------
	function readRecsCache(key) {
		if (recsMemory[key]) return recsMemory[key];
		try {
			var raw = window.sessionStorage.getItem('lwl-recs:' + key);
			if (!raw) return null;
			var obj = JSON.parse(raw);
			if (!obj || Date.now() - obj.t > RECS_TTL) return null;
			recsMemory[key] = obj.ids;
			return obj.ids;
		} catch (e) {
			return null;
		}
	}

	function writeRecsCache(key, ids) {
		recsMemory[key] = ids;
		try { window.sessionStorage.setItem('lwl-recs:' + key, JSON.stringify({ t: Date.now(), ids: ids })); } catch (e) { /* yok say */ }
	}

	function fetchRecs(productId, intent) {
		var key = intent + ':' + productId;
		var cached = readRecsCache(key);
		if (cached) return Promise.resolve(cached);
		var url = routeRoot() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10&intent=' + intent;
		return fetch(url, { headers: { Accept: 'application/json' } })
			.then(function (res) { return res.ok ? res.json() : { products: [] }; })
			.then(function (data) {
				var ids = (data.products || []).map(function (p) { return String(p.id); });
				writeRecsCache(key, ids);
				return ids;
			})
			.catch(function () { return []; });
	}

	function recsWeights(productIds, sync) {
		var weights = {};
		var pending = [];
		productIds.forEach(function (pid) {
			[['complementary', 100]].forEach(function (pair) {
				var key = pair[0] + ':' + pid;
				var ids = readRecsCache(key);
				if (!ids) {
					if (!sync) pending.push(fetchRecs(pid, pair[0]));
					return;
				}
				ids.forEach(function (id, rank) {
					weights[id] = (weights[id] || 0) + Math.max(pair[1] - rank * 5, 5);
				});
			});
		});
		return { weights: weights, pending: pending };
	}

	function applyRecsOrder(root, weights) {
		var list = root.querySelector('.lwl-upsell__list');
		if (!list) return;
		var items = Array.prototype.slice.call(list.children);
		var any = items.some(function (li) { return weights[li.getAttribute('data-product-id')]; });
		if (!any) return;
		var ranked = items.map(function (li, i) {
			var w = weights[li.getAttribute('data-product-id')] || 0;
			// Önerilen ürün 3–8 sıra öne çıkar; puan sıralaması tamamen bozulmaz.
			return { li: li, rank: i - (w > 0 ? 3 + Math.min(w, 100) / 20 : 0), i: i };
		});
		ranked.sort(function (a, b) { return a.rank - b.rank || a.i - b.i; });
		var changed = ranked.some(function (r, i) { return r.li !== items[i]; });
		if (!changed) return;
		ranked.forEach(function (r) { list.appendChild(r.li); });
	}

	function personalize(root) {
		if (root.getAttribute('data-recs') !== 'true') return;
		var ids = (root.getAttribute('data-cart-products') || '').split(',').filter(Boolean).slice(0, RECS_PRODUCTS);
		if (!ids.length) return;

		// 1) Önbellekte varsa hemen (çizimden önce) uygula
		var first = recsWeights(ids, false);
		applyRecsOrder(root, first.weights);

		// 2) Eksikler gelince, müşteri listeyle etkileşimde değilse uygula
		if (first.pending.length) {
			Promise.all(first.pending).then(function () {
				if (!document.contains(root)) return;
				var list = root.querySelector('.lwl-upsell__list');
				var picker = root.querySelector('[data-lwl-picker]');
				if ((list && list.scrollLeft > 4) || (picker && !picker.hidden)) return;
				applyRecsOrder(root, recsWeights(ids, true).weights);
			});
		}
	}

	// ---------------------------------------------------------------
	// Kaydırma okları
	// ---------------------------------------------------------------
	function updateNav(root) {
		var list = root.querySelector('.lwl-upsell__list');
		var nav = root.querySelector('.lwl-upsell__nav');
		if (!list || !nav) return;
		var overflow = list.scrollWidth > list.clientWidth + 4;
		var finePointer = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)').matches : true;
		nav.hidden = !(overflow && finePointer);
		var prev = nav.querySelector('[data-lwl-scroll="-1"]');
		var next = nav.querySelector('[data-lwl-scroll="1"]');
		if (prev) prev.disabled = list.scrollLeft <= 2;
		if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
	}

	// ---------------------------------------------------------------
	// Kurulum
	// ---------------------------------------------------------------
	function enhance(root) {
		if (root.getAttribute('data-lwl-ready')) return;
		root.setAttribute('data-lwl-ready', '1');

		personalize(root);

		var list = root.querySelector('.lwl-upsell__list');
		if (list) {
			list.addEventListener('scroll', function () { updateNav(root); }, { passive: true });
		}
		// Çekmece gizliyken ölçüm 0 olabilir; görünür olunca tekrar ölç
		requestAnimationFrame(function () { updateNav(root); });

		if (pendingStatus) {
			setStatus(root, pendingStatus);
			pendingStatus = '';
		}
	}

	function enhanceAll() {
		Array.prototype.forEach.call(document.querySelectorAll(ROOT_SEL), enhance);
	}

	document.addEventListener('click', function (e) {
		var root = e.target.closest ? e.target.closest(ROOT_SEL) : null;
		if (!root) return;

		// Ekle / Seç ve ekle
		var addBtn = e.target.closest('[data-lwl-add]');
		if (addBtn) {
			e.preventDefault();
			var variantId = addBtn.getAttribute('data-variant-id');
			if (variantId) {
				addBtn.setAttribute('aria-busy', 'true');
				addToCart(variantId).catch(function (err) {
					addBtn.removeAttribute('aria-busy');
					setStatus(root, err.message);
				});
			} else {
				openPicker(root, addBtn.closest('.lwl-upsell__item'), addBtn);
			}
			return;
		}

		// Oklar
		var arrow = e.target.closest('[data-lwl-scroll]');
		if (arrow) {
			var list = root.querySelector('.lwl-upsell__list');
			var card = list && list.querySelector('.lwl-upsell__item');
			var step = card ? (card.getBoundingClientRect().width + 10) * 2 : 280;
			list.scrollBy({ left: step * Number(arrow.getAttribute('data-lwl-scroll')), behavior: 'smooth' });
			return;
		}

		var picker = root.querySelector('[data-lwl-picker]');
		var state = picker && picker._lwlState;
		if (!state) return;

		// Seçenek
		var chip = e.target.closest('[data-lwl-chip]');
		if (chip && !chip.disabled) {
			var index = Number(chip.getAttribute('data-index'));
			state.selected[index] = chip.getAttribute('data-value');
			resolveFrom(state.product, state.selected, index);
			renderPicker(root, picker, state);
			var again = picker.querySelector('[data-lwl-chip][data-index="' + index + '"][aria-pressed="true"]');
			if (again) again.focus({ preventScroll: true });
			return;
		}

		// Kapat
		if (e.target.closest('[data-lwl-picker-close]')) {
			var opener = state.button;
			closePicker(root);
			if (opener) opener.focus({ preventScroll: true });
			return;
		}

		// Sepete ekle
		var submit = e.target.closest('[data-lwl-picker-submit]');
		if (submit && !submit.disabled) {
			var v = findVariant(state.product, state.selected);
			if (!v || !v.available) return;
			submit.disabled = true;
			submit.textContent = 'Ekleniyor…';
			addToCart(v.id).catch(function (err) {
				submit.disabled = false;
				submit.textContent = 'Sepete Ekle · ' + formatMoney(v.price, root.getAttribute('data-money-format'));
				var errEl = picker.querySelector('.lwl-picker__error');
				if (errEl) errEl.textContent = err.message;
			});
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key !== 'Escape') return;
		var picker = e.target.closest && e.target.closest('[data-lwl-picker]');
		if (!picker || picker.hidden) return;
		e.stopPropagation(); // çekmecenin kendisi kapanmasın, sadece panel
		var root = picker.closest(ROOT_SEL);
		var opener = picker._lwlState && picker._lwlState.button;
		closePicker(root);
		if (opener) opener.focus({ preventScroll: true });
	}, true);

	function start() {
		enhanceAll();
		var target = document.getElementById('CartDrawer') || document.body;
		// Tema çekmeceyi her yeniden çizdiğinde (sepet değişikliği) yeni
		// alanı hazırla. Geri çağrı ekrana çizimden önce çalışır.
		new MutationObserver(enhanceAll).observe(target, { childList: true, subtree: true });

		var bus = window.themeCore && window.themeCore.EventBus;
		if (bus && typeof bus.listen === 'function') {
			bus.listen('Toggle:CartDrawer:open', function () {
				setTimeout(function () {
					Array.prototype.forEach.call(document.querySelectorAll(ROOT_SEL), updateNav);
				}, 350);
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
